import { render, staticRenderFns } from "./MeasurementAttachmentsCard.vue?vue&type=template&id=3cbf7332"
import script from "./MeasurementAttachmentsCard.vue?vue&type=script&lang=js"
export * from "./MeasurementAttachmentsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports